import OnlyHeader from "components/Layout/OnlyHeader";
import ConfirmationModal from "components/Modals/ConfirmationModal";
import OfferModal from "components/Offers/OffersModal";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import {
  Button,
  Card,
  CardBody,
  CardHeader,
  CardImg,
  CardSubtitle,
  CardTitle,
  Col,
  Container,
  Input,
  Row,
  Spinner
} from "reactstrap";
import { fetchOffers, deleteOffer } from "store/actions/offerActions";

const Offers = () => {
  const dispatch = useDispatch();
  const history = useHistory();
  const { offers, isFetching, loading } = useSelector((state) => state.offer);
  const { user } = useSelector((state) => state.auth);
  const restaurantId = user?.restaurantID;

  const [openModal, setOpenModal] = useState(false);
  const [editMode, setEditMode] = useState(false);
  const [activeOffer, setActiveOffer] = useState(null);
  const [confirmDelete, setConfirmDelete] = useState(false);
  const [deleteTarget, setDeleteTarget] = useState(null);
  const [search, setSearch] = useState("");

  const toggleDeleteModal = () => setConfirmDelete((prev) => !prev);
  const toggleModal = () => setOpenModal((prev) => !prev);

  const handleSearch = (e) => {
    setSearch(e.target.value.toLowerCase());
  };

  const handleDelete = (offer) => {
    setDeleteTarget(offer);
    setConfirmDelete(true);
  };

  const confirmDeleteOffer = async () => {
    if (!deleteTarget) return;
    try {
      await dispatch(deleteOffer(deleteTarget.id, deleteTarget.image));
    } finally {
      setConfirmDelete(false);
      setDeleteTarget(null);
    }
  };

  const handleEdit = (offer) => {
    setActiveOffer(offer);
    setEditMode(true);
    setOpenModal(true);
  };

  const handleAddNew = () => {
    setActiveOffer(null);
    setEditMode(false);
    setOpenModal(true);
  };

  useEffect(() => {
    if (!restaurantId) return;
    const unsubscribe = dispatch(fetchOffers(restaurantId));
    return () => unsubscribe();
  }, [restaurantId, dispatch]);

  return (
    <>
      <OnlyHeader />
      <Container className="mt--7" fluid>
        <Row>
          <div className="col">
            <Card className="shadow">
              <CardHeader className="d-flex flex-column flex-lg-row justify-content-between align-items-start align-items-lg-center px-2 px-lg-4">
                <Col xs="12" lg="3" xl="6" className="mb-3 mb-lg-0">
                  <div className="d-flex align-items-center">
                    <Button
                      size="sm"
                      color="primary"
                      onClick={() => history.goBack()}
                    >
                      <i className="fas fa-arrow-left " />
                    </Button>

                    <h3 className="mb-0">Offers</h3>
                  </div>
                </Col>
                <Row className="w-100 mx-0">
                  <Col xs="12" sm="8" lg="7" className="mb-3 mb-sm-0">
                    <Input
                      placeholder="Search by offer title"
                      value={search}
                      onChange={handleSearch}
                    />
                  </Col>
                  <Col xs="12" sm="4" lg="5">
                    <Button
                      className="w-100"
                      color="primary"
                      disabled={loading}
                      onClick={handleAddNew}
                    >
                      Add Offer
                    </Button>
                  </Col>
                </Row>
              </CardHeader>

              <CardBody>
                {isFetching ? (
                  <div className="d-flex justify-content-center align-items-center py-5">
                    <Spinner color="primary" />
                  </div>
                ) : offers?.length !== 0 ? (
                  <Row className="p-0 p-lg-3">
                    {offers
                      ?.filter((offer) =>
                        offer?.title?.toLowerCase().includes(search)
                      )
                      .map((offer) => (
                        <Col
                          key={offer?.id}
                          xl={4}
                          lg={4}
                          md={6}
                          sm={6}
                          xs={12}
                          className="mb-4"
                        >
                          <Card className="w-100 h-100 shadow-sm overflow-hidden border border-gray">
                            <CardHeader
                              className="relative w-100 p-0 overflow-hidden"
                              style={{ height: "175px" }}
                            >
                              <CardImg
                                src={offer?.image}
                                className="w-100 h-100"
                                style={{ objectFit: "cover" }}
                                alt="offer img"
                              />
                            </CardHeader>
                            <CardBody className="px-3 py-2 bg-secondary d-flex flex-column justify-content-between">
                              <div className="mb-2">
                                <CardTitle tag="h3" className="text-capitalize">
                                  {offer?.title}
                                </CardTitle>
                                <CardSubtitle>
                                  {user?.currency || "$"}
                                  {offer?.price}
                                </CardSubtitle>
                              </div>
                              <div className="d-flex justify-content-end gap-2">
                                <Button
                                  color="primary"
                                  size="sm"
                                  disabled={loading}
                                  onClick={() => handleEdit(offer)}
                                >
                                  Edit
                                </Button>
                                <Button
                                  color="danger"
                                  size="sm"
                                  disabled={loading}
                                  onClick={() => handleDelete(offer)}
                                >
                                  Delete
                                </Button>
                              </div>
                            </CardBody>
                          </Card>
                        </Col>
                      ))}
                  </Row>
                ) : (
                  <div className="d-flex flex-column justify-content-center align-items-center py-5">
                    No Offer found
                  </div>
                )}
              </CardBody>
            </Card>
          </div>
        </Row>
      </Container>

      <OfferModal
        isOpen={openModal}
        onClose={toggleModal}
        editMode={editMode}
        data={activeOffer}
        restaurantId={restaurantId}
      />
      <ConfirmationModal
        isOpen={confirmDelete}
        toggle={toggleDeleteModal}
        onConfirmation={confirmDeleteOffer}
        isLoading={loading}
        title="Delete Offer?"
        text="This action cannot be undone."
      />
    </>
  );
};

export default Offers;
